// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23IPZ","rootParamsCollapsed":"styles_rootParamsCollapsed__1Yxha","rootPreviewFull":"styles_rootPreviewFull__rnCw-","loader":"styles_loader__17ZC2"};